import { render, staticRenderFns } from "./HotLinePop.vue?vue&type=template&id=471d197b&scoped=true"
import script from "./HotLinePop.vue?vue&type=script&lang=js"
export * from "./HotLinePop.vue?vue&type=script&lang=js"
import style0 from "./HotLinePop.vue?vue&type=style&index=0&id=471d197b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471d197b",
  null
  
)

export default component.exports